module.exports = "messages-container{overflow:auto;padding:15px;padding-bottom:20px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/chat-box/chat-box.component.scss
// module id = 1047
// module chunks = 0